import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0911e944"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading-background" }, null, -1))
const _hoisted_2 = { class: "loading-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "spinner" })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "label"
}
const _hoisted_5 = ["innerHTML"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["loading-bar", {'loading-label': _ctx.labelHtml}])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.labelHtml)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", { innerHTML: _ctx.labelHtml }, null, 8, _hoisted_5)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}